const delay = async (millis) => new Promise((resolve) => setTimeout(resolve, millis));

export default delay;
